import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import translate from '../translate';
import {
  dayPropGetter,
  eventPropGetter,
} from './helpers/calendarUtilityFunctions';

// Set Monday as the first day of the week globally
moment.updateLocale('default', {
  week: {
    dow: 1, // Monday is the first day of the week
  },
});

const localizer = momentLocalizer(moment);

function BravonAgenda(props) {
  const {
    views,
    step,
    onRangeChange,
    dayPropGetter: dayPropGetterParam,
    eventPropGetter: eventPropGetterParam,
    events,
    popoverClass,
    popoverContent: PopoverContent,
  } = props;

  const [selectedEvent, setSelectedEvent] = useState(null); // Store the clicked event
  const [popoverVisible, setPopoverVisible] = useState(false); // Toggle popover visibility
  const [popoverPosition, setPopoverPosition] = useState({ top: 0, left: 0 }); // Store popover position

  const popoverRef = useRef(null); // Ref for popover to detect outside clicks

  // Close popover when clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setPopoverVisible(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popoverRef]);

  const handleEventClick = (event, e) => {
    // Set the event and calculate the popover's position
    setSelectedEvent(event);
    // Get the event target element (the event box)
    const eventBox = e.target.getBoundingClientRect();
    setPopoverPosition({
      top: eventBox.top + 100, // Position popover on top of the event box with slight padding
      left: eventBox.left + 50, // Align horizontally with the event box
    });
    setPopoverVisible(true); // Show the popover
  };

  return (
    <div className="calendar-wrapper">
      <Calendar
        localizer={localizer}
        events={events}
        style={{ height: 500 }}
        views={views}
        step={step}
        dayPropGetter={dayPropGetterParam}
        eventPropGetter={eventPropGetterParam}
        onRangeChange={onRangeChange}
        dayLayoutAlgorithm="no-overlap"
        onSelectEvent={handleEventClick} // Handle event click
      />
      {popoverVisible && selectedEvent && (
        <div
          ref={popoverRef}
          className={popoverClass}
          style={{ top: popoverPosition.top, left: popoverPosition.left }}
        >
          <PopoverContent event={selectedEvent} />
        </div>
      )}
    </div>
  );
}

BravonAgenda.propTypes = {
  onRangeChange: PropTypes.func.isRequired,
  views: PropTypes.arrayOf(PropTypes.string),
  step: PropTypes.number,
  dayPropGetter: PropTypes.func,
  eventPropGetter: PropTypes.func,
  events: PropTypes.arrayOf(PropTypes.shape({})),
  popoverClass: PropTypes.string,
  popoverContent: PropTypes.func,
};

BravonAgenda.defaultProps = {
  views: ['month', 'week', 'day'], // types of view can also include 'agenda' & 'work-week'
  step: 30, // Determines the selectable time increments in week and day views
  dayPropGetter,
  eventPropGetter,
  events: [],
  popoverClass: 'my-agenda-popover-container',
  popoverContent: null,
};

export default translate(BravonAgenda);
